import LegalPage from "./LegalPage";

const SECCIONES = [
    {
        titulo: "Objeto",
        texto: "Estos Términos y Condiciones regulan el acceso y uso del sitio web de BIZecomacademy (en adelante, «el sitio») y del contenido educativo que en él se presenta. Al navegar por el sitio o agendar una consultoría, aceptas estos términos. Si no estás de acuerdo, por favor no uses el sitio.",
    },
    {
        titulo: "Descripción del servicio",
        texto: "BIZecomacademy ofrece formación digital sobre venta de productos online bajo el modelo de pago contra entrega (COD), incluyendo módulos grabados, llamadas en vivo, comunidad y acompañamiento. La consultoría gratuita ofrecida en este sitio es una sesión informativa de 20 minutos por Google Meet, sin costo ni compromiso de compra.",
    },
    {
        titulo: "Sin garantía de resultados",
        texto: "Los resultados mostrados en este sitio son de alumnos reales, pero los resultados individuales varían según el esfuerzo, el capital y la ejecución de cada persona. Nada en este sitio constituye una promesa o garantía de ingresos. El ecommerce implica riesgo, incluida la posible pérdida del capital invertido. Este sitio no está afiliado a Meta Platforms, Inc. ni a ninguna otra plataforma mencionada.",
    },
    {
        titulo: "Propiedad intelectual",
        texto: "Todo el contenido del sitio (textos, videos, imágenes, carátulas, logotipos y materiales del programa) es propiedad de BIZecomacademy o de sus licenciantes y está protegido por las leyes de propiedad intelectual. No está permitida su reproducción, distribución o uso comercial sin autorización expresa por escrito.",
    },
    {
        titulo: "Uso aceptable",
        texto: "Te comprometes a usar el sitio de forma lícita, sin intentar dañar, interrumpir o acceder de forma no autorizada a sus sistemas, y sin suplantar la identidad de terceros al agendar consultorías o completar formularios.",
    },
    {
        titulo: "Condiciones comerciales",
        texto: "Las condiciones específicas de compra del programa — precio, forma de pago, acceso y política de reembolso, si aplica — se informan de forma clara antes de cualquier pago, durante la consultoría o en el canal de venta correspondiente. Ningún cobro se realiza a través de esta página.",
    },
    {
        titulo: "Limitación de responsabilidad",
        texto: "El sitio y su contenido se ofrecen «tal cual». No garantizamos disponibilidad ininterrumpida ni ausencia de errores. En la máxima medida permitida por la ley, no seremos responsables de daños indirectos, lucro cesante o decisiones de negocio tomadas con base en el contenido informativo del sitio.",
    },
    {
        titulo: "Enlaces y servicios de terceros",
        texto: "El sitio integra o enlaza servicios de terceros (Vimeo, YouTube, Google Meet y el sistema de agendamiento). No controlamos ni asumimos responsabilidad por el contenido, las políticas o el funcionamiento de dichos servicios.",
    },
    {
        titulo: "Modificaciones y ley aplicable",
        texto: "Podemos modificar estos términos en cualquier momento; la versión vigente será la publicada en esta página. Estos términos se rigen por las leyes de la República Dominicana. Para cualquier consulta sobre estos términos, contáctanos a través del formulario de agendamiento de este sitio.",
    },
];

export default function Terminos() {
    return <LegalPage titulo="Términos y Condiciones" secciones={SECCIONES} />;
}
